const contactTypes = new Set(["contactMessage", "contactsArrayMessage", "vcard", "multi_vcard"]);

const decodeText = value => value.replace(/\\([nN,;:\\])/g, (_, escaped) =>
  escaped.toLowerCase() === "n" ? " " : escaped
).replace(/\s+/g, " ").trim();

const unfold = body => body
  // Some older message bodies contain serialized line endings instead of actual newlines.
  .replace(/\\r\\n|\\n(?=[ \t]|(?:[a-z0-9_-]+\.)?[a-z0-9_-]+(?:;[^:\r\n\\]*)?:)/gi, "\n")
  .replace(/\r\n?/g, "\n")
  .replace(/\n[ \t]/g, "");

export const normalizeVcardNumber = value => {
  if (typeof value !== "string" && typeof value !== "number") return "";
  let phone = String(value).trim().replace(/^tel:/i, "");
  try { phone = decodeURIComponent(phone); } catch (_) { return ""; }
  // A LID/JID, an extension or arbitrary text must never become a different telephone.
  phone = phone.split(";")[0].trim();
  if (!/^\+?[\d\s().-]+$/.test(phone)) return "";
  const digits = phone.replace(/\D/g, "");
  return /^\d{8,15}$/.test(digits) ? digits : "";
};

const structuredName = value => {
  const parts = [];
  let current = "";
  let escaped = false;
  for (const char of value) {
    if (char === ";" && !escaped) {
      parts.push(decodeText(current));
      current = "";
    } else {
      current += char;
    }
    escaped = char === "\\" && !escaped;
  }
  parts.push(decodeText(current));
  const [family, given, additional, prefix, suffix] = parts;
  return [prefix, given, additional, family, suffix].filter(Boolean).join(" ");
};

export const isContactMessage = (body, mediaType) =>
  contactTypes.has(mediaType) || (typeof body === "string" && /BEGIN:VCARD/i.test(body));

export const parseVcards = body => {
  if (typeof body !== "string") return [];
  const text = unfold(body);
  const cards = [];
  const blocks = /BEGIN:VCARD([\s\S]*?)(?=END:VCARD|BEGIN:VCARD|$)/gi;
  let block;
  while ((block = blocks.exec(text))) {
    let fullName = "";
    let fallbackName = "";
    let number = "";
    let whatsappNumber = "";
    for (const line of block[1].split("\n")) {
      const colon = line.indexOf(":");
      if (colon < 0) continue;
      const header = line.slice(0, colon).trim();
      const value = line.slice(colon + 1).trim();
      const property = header.split(";")[0].replace(/^.*\./, "").toUpperCase();
      if (property === "FN" && !fullName) fullName = decodeText(value);
      if (property === "N" && !fallbackName) fallbackName = structuredName(value);
      if (property === "TEL") {
        const waid = header.match(/(?:^|;)waid=(?:"([^"]*)"|([^;]*))/i);
        if (waid && !whatsappNumber) whatsappNumber = normalizeVcardNumber(waid[1] || waid[2]);
        if (!number) number = normalizeVcardNumber(value);
      }
    }
    cards.push({ name: fullName || fallbackName, number: whatsappNumber || number });
  }
  return cards;
};

export const formatMessagePreview = (body, mediaType) => {
  if (!isContactMessage(body, mediaType)) return typeof body === "string" ? body : "";
  const cards = parseVcards(body);
  if (cards.length > 1) return "Contatos compartilhados (" + cards.length + ")";
  if (cards[0]?.name) return "Contato compartilhado: " + cards[0].name;
  return mediaType === "contactsArrayMessage" || mediaType === "multi_vcard"
    ? "Contatos compartilhados"
    : "Contato compartilhado";
};
